<toaster></toaster>
<app-nav></app-nav>
<router-outlet></router-outlet>
